import axios from "axios";
import { banner, webView } from "../../variables/webView";
import GetQrLink from "./getQrLink";
export { GetQrLink };
let token = window.token;

export const Text = async (data) => {
  const response = await axios.post(
    webView ? `/text/ajax/new${banner}` : `/text/ajax/new`,
    {
      get_by_ajax: true,
      text: data[0],
      advertisingIabCategories: data[1],
      qrTitle: data[2],
      type: 15,
      token: token,
    }
  );
  return response.data;
};

export const TextEdit = async (data) => {
  const response = await axios.post(`/text/ajax/edit/${data[0]}`, {
    get_by_ajax: true,
    text: data[1],
    advertisingIabCategories: data[2],
    qrTitle: data[3],
    type: 15,
    token: token,
  });
  return response.data;
};
